import { useEffect } from "react";
import { Navigate, redirect } from "react-router-dom";

export default function FwUpdate() {
    useEffect(() => {
        window.location.href = "https://support.nextbase.com/hc/en-gb/articles/18938346035869-How-to-update-your-IQ-Firmware"
    })

    return <></>;
}